import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { FooterComponent } from './footer.component';

@NgModule({
  imports: [
    SharedModule,
  ],

  declarations: [
    FooterComponent,
  ],

  exports: [
    FooterComponent,
  ],
})
export class FooterModule {
}



// WEBPACK FOOTER //
// ./src/app/footer/footer.module.ts